<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { $, defineSchema } from '@bagelink/vue'
const schema = defineSchema({
	label: $.text('Button label', { default: 'Learn more' }),
	link: $.text('Destination', { default: '#' }),
	icon: $.text('Icon'),
	iconPosition: $.select('Icon position', [
		{ label: 'Start', value: 'start' },
		{ label: 'End', value: 'end' },
	], { default: 'end' }).if('icon pr'),
	style: $.select('Style', [
		{ label: 'Filled', value: 'filled' },
		{ label: 'Outline', value: 'outline' },
		{ label: 'Flat', value: 'flat' },
		{ label: 'Underline', value: 'underline' },
	], { default: 'filled' }),
	color: $.select('Color', [
		{ label: 'Primary', value: 'primary' },
		{ label: 'Secondary', value: 'secondary' },
		{ label: 'Black', value: 'black' },
		{ label: 'White', value: 'white' },
	], { default: 'primary' }),
	align: $.select('Alignment', [
		{ label: 'Start', value: 'start' },
		{ label: 'Center', value: 'center' },
		{ label: 'End', value: 'end' },
	], { default: 'center' }),
	fullWidth: $.checkbox('Full width', { default: false }),
	compact: $.checkbox('Compact spacing', { default: false }),
})
export const Button = defineBlock({
	name: 'Button',
	label: 'Button',
	icon: 'smart_button',
	thumbnail: '/block-thumbs/Button.svg',
	category: 'General',
	order: 112,
	schema,
})
</script>
<script setup lang="ts">
import { computed } from 'vue'
import { normalizeLink } from '@bagelink/blox'
import { Btn } from '@bagelink/vue'
const props = defineProps<{
	label?: string
	link?: string
	icon?: string
	iconPosition?: 'start' | 'end'
	style?: 'filled' | 'outline' | 'flat' | 'underline'
	color?: 'primary' | 'secondary' | 'black' | 'white'
	align?: 'start' | 'center' | 'end'
	fullWidth?: boolean
	compact?: boolean
}>()

const alignmentClass = computed(() => ({
	start: 'justify-content-start',
	center: 'justify-content-center',
	end: 'justify-content-end',
}[props.align ?? 'center']))
</script>

<template>
	<div
		class="flex px-1"
		:class="[alignmentClass, compact ? 'py-05' : 'py-1']"
	>
		<Btn
			v-if="label && link"
			:value="label"
			:href="normalizeLink(link)"
			:icon="iconPosition === 'start' ? icon : undefined"
			:icon-end="iconPosition !== 'start' ? icon : undefined"
			:color="color"
			:outline="style === 'outline'"
			:flat="style === 'flat' || style === 'underline'"
			:class="{ underline: style === 'underline' }"
			:full-width="fullWidth"
		/>
	</div>
</template>
